import ja from './ja.json'
import en from './en.json'

export default {
  ja,
  en
}